import type { PopupColumnGap } from 'blocks/Popup'

import { styled } from '@linaria/react'
import { IconSC, IconSizes } from 'atoms/Icon'
import { COLOR } from 'vars/color'
import { CORNERS } from 'vars/corners'
import { FIXED_INDENTS } from 'vars/fixed-indents'
import { MEDIA } from 'vars/media'

export const InfoPopupOverlaySC = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: var(${COLOR.SURFACE_OPACITY_DARK_70});
`

export const InfoPopupSC = styled.div<{
  gap: PopupColumnGap
  backgroundColor: COLOR
  backgroundGradient?: COLOR
  width?: string
}>`
  display: flex;

  align-items: center;
  flex-direction: column;
  padding: var(${FIXED_INDENTS.INDENT_30});
  gap: ${({ gap }) => `var(${gap})`};
  align-items: start;

  background-color: ${({ backgroundColor }) => `var(${backgroundColor})`};
  border-radius: var(${CORNERS.CORNERS_10});
  background-image: ${({ backgroundGradient }) => `var(${backgroundGradient})`};

  ${MEDIA.MIN_600} {
    width: ${({ width }) => width ?? '528px'};
  }

  ${MEDIA.MAX_599} {
    width: 100vw;
    height: 100dvh;
  }

  ${MEDIA.MIN_600} {
    padding: var(${FIXED_INDENTS.INDENT_40});
  }

  ${MEDIA.MIN_1920} {
    padding: var(${FIXED_INDENTS.INDENT_50});
  }
`

export const CloseWrapperSC = styled.div`
  display: flex;
  width: 100%;
  justify-content: end;

  ${IconSC} {
    ${MEDIA.MIN_1240} {
      font-size: ${IconSizes.xxMedium};
    }
  }
`

export const HeaderWrapperSC = styled.div`
  padding: var(${FIXED_INDENTS.INDENT_20}) var(${FIXED_INDENTS.INDENT_30})
    var(${FIXED_INDENTS.INDENT_30});

  ${MEDIA.MIN_600} {
    padding: var(${FIXED_INDENTS.INDENT_20}) var(${FIXED_INDENTS.INDENT_20})
      var(${FIXED_INDENTS.INDENT_40});
  }

  ${MEDIA.MIN_1240} {
    padding: var(${FIXED_INDENTS.INDENT_20}) var(${FIXED_INDENTS.INDENT_80})
      var(${FIXED_INDENTS.INDENT_40});
  }

  ${MEDIA.MIN_1920} {
    padding: var(${FIXED_INDENTS.INDENT_20}) var(${FIXED_INDENTS.INDENT_110})
      var(${FIXED_INDENTS.INDENT_40});
  }
`

export const DescriptionWrapperSC = styled.div`
  padding: var(${FIXED_INDENTS.INDENT_0}) var(${FIXED_INDENTS.INDENT_30});
  margin-bottom: var(${FIXED_INDENTS.INDENT_30});

  ${MEDIA.MIN_600} {
    padding: var(${FIXED_INDENTS.INDENT_0}) var(${FIXED_INDENTS.INDENT_20});
    margin-bottom: var(${FIXED_INDENTS.INDENT_20});
  }

  ${MEDIA.MIN_1240} {
    padding: var(${FIXED_INDENTS.INDENT_0}) var(${FIXED_INDENTS.INDENT_80});
    margin-bottom: var(${FIXED_INDENTS.INDENT_80});
  }

  ${MEDIA.MIN_1920} {
    padding: var(${FIXED_INDENTS.INDENT_0}) var(${FIXED_INDENTS.INDENT_110});
    margin-bottom: var(${FIXED_INDENTS.INDENT_110});
  }
`
